import { makeStyles } from '@material-ui/styles'
import { colors } from '../../colors';

export const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    height: "calc(100vh - 4rem)",
    flexDirection: "column",
    justifyContent: "center",
    "& h1": {
      color: colors.turquoise,
    },
    "& img": {
      width: "6rem",
      marginBottom: "1rem",
    },
  },
  description: {
    color: colors.darkDefault,
    fontSize: '1.8rem',
    '& span': {
      fontWeight: '700',
    },
  },
  button: {
    width: "8rem",
    fontSize: "1.2rem",
    alignSelf: "center",
    marginTop: "3rem",

    color: "#fff",
    backgroundColor: colors.default,
    transition: 'filter 0.2s',
    '&:hover': {
      color: "#fff",
      backgroundColor: colors.default,
      filter: "brightness(0.9)",
    }
  }
})